import { render, staticRenderFns } from "./DownloadWidget.vue?vue&type=template&id=e9827e5e&"
import script from "./DownloadWidget.vue?vue&type=script&lang=js&"
export * from "./DownloadWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports